import { render, staticRenderFns } from "./Section15.vue?vue&type=template&id=29859d07&scoped=true"
import script from "./Section15.vue?vue&type=script&lang=js"
export * from "./Section15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29859d07",
  null
  
)

export default component.exports